// AIDEV-NOTE: cdnproduction, not the per-env CDN. These banners live only in the production bucket and
// are referenced from every environment, which is the existing behaviour — they were previously fetched
// straight from s3.amazonaws.com. Going through the CDN keeps them working if the production bucket ever
// moves to Origin Access Control, where direct unsigned S3 reads stop working.
const THUMBNAIL_BASE_URL = 'https://cdnproduction.teachtci.com/system/games/ui';

export const HARDCODED_THUMBNAIL_URL = {
  'adventures in the sky': `${THUMBNAIL_BASE_URL}/games-library_adventures-in-the-sky_banner.png`,
  'aventuras en el cielo': `${THUMBNAIL_BASE_URL}/games-library_adventures-in-the-sky_banner.png`,
  'community cleanup': `${THUMBNAIL_BASE_URL}/games-library_community-cleanup_banner.png`,
  'desarrollado por pizza': `${THUMBNAIL_BASE_URL}/games-library_powered-by-pizza_banner.png`,
  'el museo de las piezas': `${THUMBNAIL_BASE_URL}/games-library_museum-of-parts_banner.png`,
  'juego de capitales de estado': `${THUMBNAIL_BASE_URL}/State_Capitals_Game_Thumbnail.png`,
  'limpieza de la comunidad': `${THUMBNAIL_BASE_URL}/games-library_community-cleanup_banner.png`,
  'powered by pizza': `${THUMBNAIL_BASE_URL}/games-library_powered-by-pizza_banner.png`,
  'state capitals game': `${THUMBNAIL_BASE_URL}/State_Capitals_Game_Thumbnail.png`,
  'the museum of parts': `${THUMBNAIL_BASE_URL}/games-library_museum-of-parts_banner.png`,
};
